import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { RefAnneeType } from './ref-annee-type.model';
import { RefObjetFacture } from './ref-objet-facture.model';
import { ModeleArticle } from './modele-article.model';
import { ArrayClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class ModeleFacturation {
    static jsonMap = {
        id: { key: 'id', optional: true },
        libelle: { key: 'libelle' },
        refObjetFacture: {
            key: 'idRefObjetFacture',
            converter: new (DataIdConverterFactory.build(RefObjetFacture, 'refObjetFactureList'))()
        },
        refAnneeType: { key: 'idRefAnneeType', converter: new (DataIdConverterFactory.build(RefAnneeType, 'refAnneeTypeList'))() },
        idOrganisme: { key: 'idOrganisme' },
        idDomaine: { key: 'idDomaine' },
        isSupprime: { key: 'isSupprime' },
        isGroupeOperateur: { key: 'isGroupeOperateur' },
        isUsite: { key: 'isUsite' },
        isFacturationDirecte: { key: 'isFacturationDirecte' },
        modeleArticleList: { key: 'modeleArticleList', converter: new (ArrayClassConverterFactory.build(ModeleArticle))() }
    };

    id: number;
    libelle: string;
    refObjetFacture: RefObjetFacture;
    refAnneeType: RefAnneeType;
    idOrganisme: number;
    idDomaine: number;
    isSupprime: boolean;
    isGroupeOperateur: boolean;
    isUsite: boolean;
    isFacturationDirecte: boolean;
    modeleArticleList: ModeleArticle[];
}
